import { AppUpdate } from '@/types/updates';

export const update_2025_10: AppUpdate = {
  id: 'escape-mode-2025-10',
  slug: 'introducing-escape-mode-physics',
  title: 'Escape Mode: Creating High-Tension Content',
  description: 'In January, we introduced a completely new way to play. Escape Mode turned physics simulations into high-stakes digital stories.',
  date: 'January 5, 2026',
  timestamp: 1767571200,
  category: 'FEATURE',
  version: '0.4.0',
  readTime: '7 min read',
  author: {
    name: 'FCG Dev',
    role: 'Lead Architect'
  },
  content: [
    {
      type: 'heading',
      content: 'The Evolution of Narrative Physics'
    },
    {
      type: 'text',
      content: 'We noticed something interesting in January: people were using our simulations to tell stories. "Will the ball stay in?" "Can it find the exit?" This inspired us to build Escape Mode—a specialized environment designed specifically for high-tension visual storytelling.'
    },
    {
      type: 'heading',
      content: 'What is Escape Mode?'
    },
    {
      type: 'text',
      content: 'Escape Mode challenges the traditional "trapped" simulation. Instead of a solid wall, the outer boundary becomes a rotating, evolving gate. Balls must navigate through a gap to "escape" into the outer void. It sounds simple, but the physics of a rotating gap creates mesmerizing, unpredictable patterns.'
    },
    {
      type: 'list',
      content: [
        'Rotating Boundary Logic: We added precision controls for rotation degrees per frame.',
        'Dynamic Gap Sizes: You can now shrink or expand the exit gap during the simulation.',
        'Expansion/Contraction: The entire world can now pulse, forcing balls toward the center or pushing them out.',
        'Collision Counters: A new HUD element that tracks how many times a ball hits the wall before finding freedom.'
      ]
    },
    {
      type: 'heading',
      content: 'Designed for Creators'
    },
    {
      type: 'text',
      content: 'Escape Mode was built with TikTok, Instagram Reels, and YouTube Shorts in mind. The "will they or won\'t they" aspect of the balls finding the gap provides a natural hook for viewers. This update also included our first "Vertical Studio" layout optimizations to help creators record for mobile platforms.'
    },
    {
      type: 'highlight',
      content: 'By introducing a goal (the escape), we transformed a technical simulation into a captivating visual game.'
    },
    {
      type: 'heading',
      content: 'Visual FX: The Outside Void'
    },
    {
      type: 'text',
      content: 'When a ball escapes, it doesn\'t just disappear. We built a specialized "Outside Collider" system. Once a ball leaves the primary circle, it enters a secondary physics layer with its own rules, gravity, and visual effects, creating a satisfying "winning" moment.'
    }
  ]
};
